(() => {
  'use strict';
  const directory = document.querySelector('[data-field-guide] [data-directory]');
  const data = window.DG_FIELD_GUIDE;
  if (!directory || !data || !Array.isArray(data.strains)) return;
  const search = directory.querySelector('input[name="q"]');
  const type = directory.querySelector('select[name="type"]');
  const flavor = directory.querySelector('select[name="flavor"]');
  const sort = directory.querySelector('select[name="sort"]');
  const results = directory.querySelector('[data-results]');
  const pagination = directory.querySelector('[data-pagination]');
  const status = directory.querySelector('[data-result-count]');
  const template = results.firstElementChild;
  if (!template) return;
  const cardTemplate = template.cloneNode(true);
  const size = 24;
  let letter = '';
  let page = Number(directory.dataset.page) || 1;
  let debounce;
  const normalize = value => String(value).toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const entries = data.strains.map(strain => ({ ...strain, searchText: normalize([strain.name, ...(strain.aliases || []), ...(strain.aromas || []), ...(strain.experiences || [])].join(' ')) }));
  const updateUrl = () => {
    const next = new URL(location.href);
    [['q', search.value.trim()], ['type', type.value], ['flavor', flavor.value], ['sort', sort.value === 'az' ? '' : sort.value], ['letter', letter], ['p', page === 1 && Number(directory.dataset.page) === 1 ? '' : String(page)]].forEach(([key, value]) => value ? next.searchParams.set(key, value) : next.searchParams.delete(key));
    history.replaceState(null, '', next);
  };
  const createCard = strain => {
    const node = cardTemplate.cloneNode(true);
    node.dataset.tone = String([...strain.slug].reduce((sum, char) => sum + char.charCodeAt(0), 0) % 5);
    node.querySelector('.fg-card-link').href = '/pages/strain-' + strain.slug;
    node.querySelector('.fg-card-category').textContent = strain.category;
    node.querySelector('.fg-monogram').textContent = strain.name.split(/\s+/).slice(0, 2).map(word => word[0]).join('').toUpperCase();
    node.querySelector('h3').textContent = strain.name;
    node.querySelector('.fg-card-copy > p').textContent = strain.aromas.length ? strain.aromas.slice(0, 3).join(' · ') : 'A closer look at this cultivar';
    node.querySelector('.fg-card-meta > span').textContent = strain.aromas.length ? 'Reported profile' : 'Research profile';
    return node;
  };
  const render = (save = true) => {
    const query = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
    const matches = entries.filter(strain => query.every(term => strain.searchText.includes(term)) && (!type.value || strain.category === type.value) && (!flavor.value || strain.aromas.includes(flavor.value)) && (!letter || (letter === '#' ? !/^[a-z]/i.test(strain.name) : normalize(strain.name).startsWith(letter.toLowerCase()))));
    matches.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base', numeric: true }) * (sort.value === 'za' ? -1 : 1));
    const count = matches.length;
    const pages = Math.max(1, Math.ceil(count / size));
    page = Math.max(1, Math.min(page, pages));
    const fragment = document.createDocumentFragment();
    matches.slice((page - 1) * size, page * size).forEach(strain => fragment.append(createCard(strain)));
    if (!count) {
      const empty = document.createElement('div'); empty.className = 'fg-empty';
      const heading = document.createElement('h3'); heading.textContent = 'No matches just yet.';
      const message = document.createElement('p'); message.textContent = 'Try another spelling, a broader flavor, or reset the filters.';
      empty.append(heading, message); fragment.append(empty);
    }
    results.replaceChildren(fragment);
    status.textContent = count ? `${count} ${count === 1 ? 'profile' : 'profiles'} · Showing ${(page - 1) * size + 1}–${Math.min(page * size, count)}` : '0 profiles found';
    pagination.replaceChildren();
    if (pages > 1) {
      for (let number = 1; number <= pages; number++) {
        if (number !== 1 && number !== pages && Math.abs(number - page) > 2) {
          if (number === page - 3 || number === page + 3) { const dots = document.createElement('span'); dots.textContent = '…'; pagination.append(dots); }
          continue;
        }
        const button = document.createElement('button'); button.type = 'button'; button.textContent = number; button.setAttribute('aria-label', `Page ${number}`);
        if (number === page) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => { page = number; render(); directory.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); });
        pagination.append(button);
      }
    }
    directory.querySelectorAll('[data-letter]').forEach(button => { button.classList.toggle('is-active', button.dataset.letter === letter); button.setAttribute('aria-pressed', String(button.dataset.letter === letter)); });
    if (save) updateUrl();
  };
  const readUrl = () => {
    const params = new URLSearchParams(location.search);
    search.value = params.get('q') || ''; type.value = params.get('type') || ''; flavor.value = params.get('flavor') || ''; sort.value = params.get('sort') === 'za' ? 'za' : 'az';
    letter = /^[A-Z#]$/.test(params.get('letter') || '') ? params.get('letter') : '';
    page = Math.max(1, Number(params.get('p')) || Number(directory.dataset.page) || 1);
    render(false);
  };
  directory.querySelector('form').addEventListener('submit', event => { event.preventDefault(); clearTimeout(debounce); page = 1; render(); });
  search.addEventListener('input', () => { clearTimeout(debounce); debounce = setTimeout(() => { page = 1; render(); }, 160); });
  [type, flavor, sort].forEach(control => control.addEventListener('change', () => { page = 1; render(); }));
  directory.querySelectorAll('[data-letter]').forEach(button => button.addEventListener('click', () => { letter = button.dataset.letter; page = 1; render(); }));
  directory.querySelector('.fg-clear').addEventListener('click', () => { search.value = ''; type.value = ''; flavor.value = ''; sort.value = 'az'; letter = ''; page = 1; render(); search.focus(); });
  window.addEventListener('popstate', readUrl);
  readUrl();
})();
